import {
	SET_VEHICLE_CONFIGURATION,
	SET_YEAR,
	SET_MAKE,
	SET_MODEL,
	SET_IMAGE,
	SET_BODYSTYLE,
	SET_PRICE,
	SET_OPTIONS,
	SET_DRIVETRAIN,
	SET_CAB,
	SET_PAINT,
	SET_INTERIOR,
	SET_TRIM,
	SET_TRIM_ID,
	SET_PACKAGES,
	SET_PACKAGES_SELECTIONS
} from '../actions/types';

export default function vehicleConfiguration(state = {}, action) {
	if (!action.error && typeof action.payload !== 'undefined') {
		switch (action.type) {
			case SET_VEHICLE_CONFIGURATION:
				return action.payload;
			case SET_YEAR:
				return {
					...state,
					year: action.payload
				};
			case SET_MAKE:
				return {
					...state,
					make: action.payload
				};
			case SET_MODEL:
				return {
					...state,
					model: action.payload
				};
			case SET_IMAGE:
				return {
					...state,
					image: action.payload
				};
			case SET_BODYSTYLE:
				return {
					...state,
					bodyStyle: action.payload
				};
			case SET_PRICE:
				return {
					...state,
					price: action.payload
				};
			case SET_TRIM:
				return {
					...state,
					trimName: action.payload
				};
			case SET_TRIM_ID:
				return {
					...state,
					trimId: action.payload
				};
			case SET_OPTIONS:
				return {
					...state,
					options: action.payload
				};
			case SET_DRIVETRAIN:
				return {
					...state,
					options: {
						...state.options,
						drivetrain: action.payload
					}
				};
			case SET_CAB:
				return {
					...state,
					options: {
						...state.options,
						cab: action.payload
					}
				};
			case SET_PAINT:
				return {
					...state,
					options: {
						...state.options,
						paint: action.payload
					}
				};
			case SET_INTERIOR:
				return {
					...state,
					options: {
						...state.options,
						interior: action.payload
					}
				};
			case SET_PACKAGES:
				return {
					...state,
					options: {
						...state.options,
						packages: action.payload
					}
				};
			case SET_PACKAGES_SELECTIONS:
				return {
					...state,
					options: {
						...state.options,
						packages: {
							...state.packages,
							selections: action.payload
						}
					}
				};
			// no default
		}
	}

	return state;
}
